import styled from 'styled-components';
import { flexPosition } from '../../styles/mixins';

export const TagList = styled.div`
  ${flexPosition({ align: 'center', justify: 'flex-end' })}
  span {
    margin-right: 10px;
    &:last-child {
      margin-right: 0px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/MarketplacesTags/style.js